import Thunk from 'src/thunks/index';
import { Data, List } from 'src/interfaces/general';
import classUserStatusActions from 'src/store/model/class_user_status';

export const endpoint = 'class_users/status';
const classUserStatus = new Thunk(endpoint);

export const fetchClassUserStatus = classUserStatus.create<
  List<Model.ClassUserStatus>,
  SearchParams.ClassUserStatus
>({
  onSuccess({ data, args, dispatch }) {
    dispatch(classUserStatusActions.updateEntities(data.data));
    dispatch(
      classUserStatusActions.updateSearch({
        params: args,
        ids: data.data.map((d) => d.id),
      }),
    );
  },
});

export const fetchClassUserStatusDetail = classUserStatus.fetchOne<
  Data<Model.ClassUserStatus>
>({
  onSuccess({ data, dispatch }) {
    dispatch(classUserStatusActions.updateEntity(data.data));
  },
});

export const createClassUserStatus = classUserStatus.create<
  Data<Model.ClassUserStatus>,
  Partial<Model.ClassUserStatus>
>({
  onSuccess({ data, dispatch }) {
    dispatch(classUserStatusActions.updateEntity(data.data));
  },
});

export const updateClassUserStatus = classUserStatus.update<
  Data<Model.ClassUserStatus>,
  Partial<Model.ClassUserStatus>
>({
  onSuccess({ data, dispatch }) {
    dispatch(classUserStatusActions.updateEntity(data.data));
  },
});

export const deleteClassUserStatus = classUserStatus.remove<
  Data<Model.ClassUserStatus>,
  Partial<Model.ClassUserStatus>
>({
  onSuccess({ data, dispatch, args }) {
    dispatch(classUserStatusActions.removeEntity(args));
  },
});

export const fetchResources = classUserStatus.fetchResources<
  void,
  SearchParams.ClassUserStatus
>('ClassUserStatus', async (arg, { dispatch }) => {
  await Promise.all([dispatch(fetchClassUserStatus({ ...arg, page: 1 }))]);
});
